import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, retry, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class FiberService {

  private baseUrl = environment.apiBaseUrl;
  public menuByRoleId$: BehaviorSubject<any> = new BehaviorSubject(null)
  productId: number;
  private userDetails$: BehaviorSubject<any> = new BehaviorSubject(null)
  private fiberFormData$: BehaviorSubject<any> = new BehaviorSubject(null);
  private applicationDetails$: BehaviorSubject<any> = new BehaviorSubject(null)
  private applicationId$: BehaviorSubject<number> = new BehaviorSubject(null)

  constructor(private http: HttpClient, private dataService: DataService) { }


  getUser(userId) {
    return this.http.get(`${this.baseUrl}/api/user/getUser/${userId}`).pipe(tap(res => {
      this.setUserDetsils(res);
    }));
  }

  getUserDetailsObs() {
    return this.userDetails$.asObservable()
  }

  setFiberFormData(details) {
    this.fiberFormData$.next(details)
  }

  getFiberFormDataObs() {
    return this.fiberFormData$.asObservable()
  }

  setUserDetsils(details) {
    this.userDetails$.next(details)
  }

  saveFiberApplication(payload) {
    return this.http.post(`${this.baseUrl}/api/Application/saveApplication`, payload)
  }

  getApplicationByAppId(applicationId: number) {
    return this.dataService.getRecord('/api/Application/GetApplicationByAppId/' + applicationId);
  }

  getApplicationDetails(applicationId: number) {
    return this.dataService.getRecord('/api/Application/getApplicationByid/' + applicationId).pipe(tap(data => {
      this.setApplicationDetails(data);
      this.setAppId(applicationId)
    }));
  }

  setAppId(applicationId) {
    this.applicationId$.next(applicationId)
  }

  getAppIdObs() {
    return this.applicationId$.asObservable()
  }

  setApplicationDetails(data) {
    this.applicationDetails$.next(data)
  }

  getApplicationDetailsObs() {
    return this.applicationDetails$.asObservable();
  }


  // getMenuByRoleIdObs() {
  //   return this.menuByRoleId$.asObservable()
  // }

  // getMenuByRole(id) {
  //   return this.http.get(`${this.baseUrl}/api/Page/GetPagesByRoleId/${id}`).pipe(tap(menu => {
  //     this.menuByRoleId$.next(menu)
  //   }))
  // }
  getMenuByRoleIdObs(id:any) {
    return this.dataService.getRecord('/api/Page/GetPagesByRoleId/'+id);
  };

  getBankList() {
    return this.http.get(`${this.baseUrl}/api/debitForm/getBankList`);
  }

  getUserBankDetails(userId) {
    return this.http.get(`${this.baseUrl}/api/Application/getExistingBankDetails/${userId}`)
  }

  getDebitOrderRun() {
    return this.http.get(`${this.baseUrl}/api/lookup/getDebitRunDateType?t=955`);
  }

  downloadDebitFormPDF(timeStamp, debitFormId) {
    let token = localStorage.getItem('token')
    const headers = new HttpHeaders({
      'Content-Type': 'application/pdf',
      // Add any additional headers as needed
    });

    // Set responseType to 'blob' in the request options
    const options = { headers, responseType: 'blob' as 'json' };
    return this.http.get(`${this.baseUrl}/api/debitForm/DownloadDebitFormReport/${debitFormId}`, options);
  };


  saveAppDocuments(payload) {
    return this.http.post(`${this.baseUrl}/api/ApplicationDocumentMapping/SaveApplicationDocuments`, payload)
  }





}
